import { mobile, tablet, tv } from 'app/device';
import { BlurBox } from 'components/ui';
import { maxCols } from 'helpers';
import styled, { css } from 'styled-components';

export const Wrapper = styled(BlurBox)`
    width: calc(98vw * ${(maxCols - 1) / maxCols});
    max-width: 98vw;
    margin-right: 1vw;
    display: flex;
    overflow: hidden;
    justify-content: right;
    --gameWindowHeight: 247px; // used in other components

    ${mobile(css`
        width: 98vw;
        --gameWindowHeight: 230px;
    `)}

    ${tablet(css`
        width: 98vw;
    `)}

    ${tv(css`
        width: 80%;
        --gameWindowHeight: 320px;
    `)}

  height: var(--gameWindowHeight);
`;

export const Cover = styled.div`
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
    width: var(--gameWindowHeight);
    height: 100%;
`;
